import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.l};
  font-weight: 500;
  margin: 1rem;
`;
